import Seo from "../../Components/SEO/Seo";
import Container from "../../Components/Container/Container";
import "../../Style/legal/legal.css";

export default function Terms() {
  return (
    <div className="legal-page">
      <Seo
        title="Terms of Use | Conectify Tech"
        description="Review the website Terms of Use and service agreements for Conectify Tech."
      />

      <Container className="legal-container">
        <header className="legal-header">
          <span className="section-eyebrow eyes">Legal Agreement</span>
          <h1 className="legal-header__title">Terms of Use</h1>
          <p className="legal-header__date">Last Updated: September 2026</p>
        </header>

        <article className="legal-card legal-content">
          <p>
            Welcome to <strong>Conectify Tech</strong>. When you visit, view, use, or access our website 
            <strong> conectify-tech.com</strong> and any applicable subdomains thereof, or any applications, 
            functionalities, content, or services provided by Conectify Tech (collectively, the “Platform”), 
            whether as a guest or a registered user, you are agreeing to these Terms of Use. Please review them carefully.
          </p>

          <h2>1. Acceptance of Terms of Use</h2>
          <p>
            If you do not agree to these Terms of Use, you are not permitted to use the Platform. Conectify Tech 
            reserves the right to modify these Terms at any time without prior notice. Your continued use of the 
            Platform following modifications signifies your acceptance of all changes.
          </p>

          <h2>2. Eligibility</h2>
          <p>
            Any access or use of the Platform by anyone under the age of 18 is prohibited. By using this Platform, 
            you represent and warrant that you are 18 years of age or older and possess the legal capacity to enter 
            into this agreement.
          </p>

          <h2>3. Privacy & Data Handling</h2>
          <p>
            Any personal information submitted through the Platform is governed by our Privacy Policy. Conectify Tech 
            processes and secures personal information in accordance with applicable global data privacy regulations 
            (including GDPR and CCPA).
          </p>

          <h2>4. Account and Security</h2>
          <p>
            When registering an account, you must provide accurate, current, and complete details. You may not 
            impersonate another individual or use credentials not expressly assigned to you. You remain fully 
            responsible for safeguarding your password and for all activities carried out through your account.
          </p>

          <h2>5. Proprietary Materials & Intellectual Property</h2>
          <p>
            All content on the Platform—including source code, text, logos, datasets, and interface graphics—is 
            the proprietary property of Conectify Tech or its licensors and is protected by international copyright laws. 
            No downloading, copying, reverse engineering, or commercial exploitation is permitted without prior written consent.
          </p>

          <h2>6. Acceptable Use Policy</h2>
          <p>You agree not to engage in any of the following prohibited activities:</p>
          <ul>
            <li>Using the Platform in any manner that impairs system performance or availability.</li>
            <li>Transmitting malware, viruses, Trojan horses, or malicious payloads.</li>
            <li>Conducting automated scraping, crawling, extraction, or data mining without written authorization.</li>
            <li>Sub-licensing, renting, republishing, or selling material accessed via the Platform.</li>
            <li>Attempting to bypass access controls or breach platform security architecture.</li>
          </ul>

          <h2>7. Warranty Disclaimer</h2>
          <div className="legal-callout">
            The Platform is provided strictly on an <strong>“AS IS”</strong> and <strong>“AS AVAILABLE”</strong> basis. 
            Conectify Tech disclaims all warranties of any kind, whether express or implied, including warranties of 
            merchantability, fitness for a particular purpose, and non-infringement.
          </div>

          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, Conectify Tech and its officers, directors, employees, 
            and affiliates shall not be liable for any indirect, incidental, punitive, or consequential damages. Total 
            aggregate liability under any circumstance shall not exceed <strong>$100.00 USD</strong>.
          </p>

          <h2>9. DMCA Copyright Notice</h2>
          <p>
            To report alleged copyright infringements, please submit a written notification with identification of the 
            work, the URL location of the infringing asset, your signature, and your contact details to:
          </p>
          <div className="legal-callout">
            <strong>Conectify Tech — Attn: Copyright Agent</strong><br />
            Email: <a href="mailto:info@conectify-tech.com">info@conectify-tech.com</a><br />
            Address: Mount Motor Gali, Ratu Road, Alkapuri, Near Kidzee School, Ranchi - 834001, Jharkhand, India
          </div>

          <h2>10. Office Contact Information</h2>
          <div className="legal-address-box">
            <div className="legal-address-card">
              <h4>India (Global HQ)</h4>
              <p>Mount Motor Gali, Ratu Road, Alkapuri</p>
              <p>Near Kidzee School, Ranchi - 834001</p>
              <p>Jharkhand, India</p>
              <p className="mt-2 text-primary font-semibold">info@conectify-tech.com</p>
            </div>
            <div className="legal-address-card">
              <h4>United States</h4>
              <p>1000 Brickell Ave Ste</p>
              <p>Miami, FL 33131</p>
              <p>USA</p>
              <p className="mt-2 text-primary font-semibold">+1 786 776 2152</p>
            </div>
          </div>
        </article>
      </Container>
    </div>
  );
}